import { useLayoutEffect, useRef, useState } from 'react';
import LandingPage from './LandingPage';
import ServicesPage from './ServicesPage';

function pageForPath(pathname) {
  return pathname === '/services' || pathname === '/services/' ? '/services' : '/';
}

export default function App() {
  const [page, setPage] = useState(() => pageForPath(window.location.pathname));
  const focusOnNavigation = useRef(false);

  useLayoutEffect(() => {
    const syncPage = () => {
      const nextPage = pageForPath(window.location.pathname);
      if (window.location.pathname !== nextPage) {
        window.history.replaceState(null, '', nextPage + window.location.search + window.location.hash);
      }
      setPage(nextPage);
    };
    syncPage();
    window.addEventListener('popstate', syncPage);
    const previousRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = 'manual';
    return () => {
      window.removeEventListener('popstate', syncPage);
      window.history.scrollRestoration = previousRestoration;
    };
  }, []);

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
    document.title = page === '/services'
      ? '우리의 서비스 · United Ad & LinkFlow | 마켓핏 AI'
      : '마켓핏 AI · 재고와 광고, 하나의 흐름으로';
    if (focusOnNavigation.current) {
      document.getElementById('main-content')?.focus({ preventScroll: true });
      focusOnNavigation.current = false;
    }
    const anchorFrame = window.location.hash
      ? requestAnimationFrame(() => document.getElementById(window.location.hash.slice(1))?.scrollIntoView({ behavior: 'auto' }))
      : 0;
    return () => cancelAnimationFrame(anchorFrame);
  }, [page]);

  const navigate = (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.currentTarget;
    if (link.target && link.target !== '_self') return;
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin) return;
    const nextPage = pageForPath(url.pathname);
    if (url.pathname !== '/' && url.pathname !== '/services' && url.pathname !== '/services/') return;
    event.preventDefault();
    if (url.href === window.location.href) return;
    window.history.pushState(null, '', url.pathname + url.search + url.hash);
    if (nextPage === page) {
      if (url.hash) document.getElementById(url.hash.slice(1))?.scrollIntoView({ behavior: 'auto' });
      else window.scrollTo({ top: 0, behavior: 'auto' });
      return;
    }
    focusOnNavigation.current = true;
    setPage(nextPage);
  };

  return page === '/services' ? <ServicesPage onNavigate={navigate} /> : <LandingPage onNavigate={navigate} />;
}
